const getPricelistCodePrefix = (pricelistCode = "") => {
    try {
        const splitPricelist = pricelistCode.split("_");
        return splitPricelist[0];
    } catch (e) {
        return null;
    }
};

export default getPricelistCodePrefix;
